/*
 * Welcome to your app's main JavaScript file!
 *
 * We recommend including the built version of this JavaScript file
 * (and its CSS file) in your base layout (base.html.twig).
 */

// any CSS you import will output into a single css file (app.css in this case)
import './styles/app.scss';

// start the Stimulus application
import './bootstrap';

import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";

import { Provider } from 'react-redux'
import store from './store'

import MapApp from './map/index'
import MemberArea from './member/MemberArea'
import AllMembers from './member/AllMembers'
import AllDownloaded from './member/AllDownloaded'
import MemberAccount from './member/MemberAccount'

const rootElement = document.getElementById('root')
ReactDOM.render(
  <Provider store={store}>
    <Router>
      <Routes>
        {
          /*
          <Route path="/embed/dashboard">
              <ApiDashboard/>
          </Route>
          */
        }
        <Route path="/" element={<MapApp />}/>
        <Route path="/species" element={<MapApp />}/>
        <Route path="/species/:scientificNameSlug" element={<MapApp />}/>
        <Route path="/countries" element={<MapApp />}/>
        <Route path="/countries/:countrySlug" element={<MapApp />}/>
        <Route path="/references" element={<MapApp />}/>
        <Route path="/references/:referenceId" element={<MapApp />}/>
        <Route path="/search" element={<MapApp />}/>
        <Route path="/study/:id" element={<MapApp />}/>
        <Route path="/member" element={<MemberArea />}/>
        <Route path="/member/all" element={<AllMembers />}/>
        <Route path="/member/downloaded-datasets" element={<AllDownloaded />}/>
        <Route exact path="/member/account" element={<MemberAccount />}/>
        <Route path="/member/account/:id" element={<MemberAccount />}/>
      </Routes>
    </Router>
  </Provider>
  ,
  rootElement
)
